import Err from '../../models/err';

export default function createBlankError(attrName, labelName) {
  return new Err({ code: Err.Code.BLANK, attr: attrName, detail: `${labelName || attrName} cannot be blank` });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/error/create_blank_error.js